"use client"

import {
  NavigateWithThread,
  EntityDetailSkeleton,
  PageContainer,
  PageHeader,
  PageHeaderLeading,
  useArtifactCanvas,
} from '@yeshuman/sdk'
import { useCallback, useRef } from 'react'
import { CandidateFitDocument } from './candidate-fit-document'
import { openApplicationApplyCanvas } from './open-application-apply-canvas'
import { useCandidateOpportunityMatchState } from '../../hooks/use-candidate-opportunity-match-state'
import type { SavedOpportunity } from '../../hooks/use-saved-opportunities'

export function CandidateOpportunityMatchPage() {
  const state = useCandidateOpportunityMatchState()
  const { openCanvas, closeCanvas } = useArtifactCanvas()
  const applyCanvasKeyRef = useRef(0)

  const handleApply = useCallback(() => {
    if (!state.opportunity) return
    openApplicationApplyCanvas({
      opportunity: state.opportunity as SavedOpportunity,
      openCanvas,
      closeCanvas,
      applyCanvasKeyRef,
      keyPrefix: 'match-apply',
    })
  }, [closeCanvas, openCanvas, state.opportunity])

  if (state.missingRequired) {
    return <NavigateWithThread to="/candidate/jobs?tab=saved" />
  }

  if (state.isLoading) {
    return <EntityDetailSkeleton variant="job" ariaLabel="Loading match" />
  }

  if (state.missingData) {
    return (
      <PageContainer>
        <PageHeaderLeading back={{ label: 'Back to saved jobs', to: '/candidate/jobs?tab=saved' }} />
        <PageHeader title="Match" description="This match could not be loaded." />
      </PageContainer>
    )
  }

  const description = state.companyName
    ? `${state.companyName} · Saved job match`
    : 'Saved job match'

  return (
    <PageContainer>
      <PageHeaderLeading back={{ label: 'Back to saved jobs', to: '/candidate/jobs?tab=saved' }} />
      <PageHeader title={state.displayTitle} description={description} />
      {state.opportunity ? (
        <CandidateFitDocument
          evaluationId={state.evaluationId}
          opportunity={state.opportunity}
          subjectLabel={state.companyName}
          onApply={handleApply}
        />
      ) : null}
    </PageContainer>
  )
}
